export default {


    NUMBER: 'number',
    STRING: 'string',
    BOOLEAN: 'boolean',
    DATE: 'date',
    MONTH: 'month',
    YEAR: 'year',
    TIME: 'time',
    GEOGRAPHY: 'geography',
    UNCERTAIN: 'uncertain'
}